/**
 * Shared constants and helpers for game creation (matchmaking, scheduled, manual).
 * Used by Dashboard/CompetitiveSessionPage and useCourtManagement.
 */

export const MATCHMAKING_ALGORITHM_NAME = 'two_stage';

export const GAME_CREATION_ORIGIN = {
  MATCHMAKING: 'matchmaking',
  SCHEDULED: 'scheduled',
  MANUAL: 'authoritative',
};

export const ensureGameCreationMeta = (meta, defaultOrigin = GAME_CREATION_ORIGIN.MANUAL) => {
  if (meta && meta.origin) {
    const sid = meta.scheduledGameId;
    const hasSid = sid != null && String(sid).trim() !== '';
    // Scheduled-game IDs must only appear when origin is scheduled; otherwise snapshot rebuild
    // or stale merges can attach a waitlist reservation UUID to a matchmaking court.
    if (hasSid && meta.origin !== GAME_CREATION_ORIGIN.SCHEDULED) {
      return {
        ...meta,
        scheduledGameId: null,
      };
    }
    return meta;
  }
  const hasSchedId = meta?.scheduledGameId != null && String(meta.scheduledGameId).length > 0;
  if (hasSchedId) {
    return {
      origin: GAME_CREATION_ORIGIN.SCHEDULED,
      algorithm: meta.algorithm ?? null,
      isAltered: Boolean(meta.isAltered),
      scheduledGameId: meta.scheduledGameId,
    };
  }
  return {
    origin: defaultOrigin,
    algorithm: defaultOrigin === GAME_CREATION_ORIGIN.MATCHMAKING ? MATCHMAKING_ALGORITHM_NAME : null,
    isAltered: false,
    scheduledGameId: null,
  };
};

export const markGameCreationAltered = (meta, defaultOrigin = GAME_CREATION_ORIGIN.MANUAL) => {
  if (!meta) {
    return ensureGameCreationMeta(null, defaultOrigin);
  }
  if (meta.origin === GAME_CREATION_ORIGIN.MANUAL) {
    return meta;
  }
  if (meta.isAltered) {
    return meta;
  }
  return { ...meta, isAltered: true };
};
